import React from 'react'
import { Stack, Box, Text } from '@chakra-ui/react'
import { numberToDollars } from '../../utils/numberToCurrency'
import { SecurityCodeTypeTypes, SecurityCodeTypeText } from '../../containers/PositionJournals/types'
interface ModalSecurityDetailsProps {
  securityCodeType: SecurityCodeTypeTypes
  securityId: string
  quantity: number | null
  amount?: number | null
}

export const ModalSecurityDetails = ({ securityCodeType, securityId, amount, quantity }: ModalSecurityDetailsProps) => {
  return (
    <Stack spacing={6}>
      <Stack direction='row' w='100%' spacing={4}>
        <Box w='50%' data-testid='securityCodeType'>
          <Text fontWeight='bold'>Security Code Type</Text>
          <Text className='test-id-security-code-type'>{SecurityCodeTypeText[securityCodeType]}</Text>
        </Box>
        <Box w='50%' data-testid='securityId'>
          <Text fontWeight='bold'>Security ID</Text>
          <Text whiteSpace='pre' className='test-id-security-id'>
            {securityId}
          </Text>
        </Box>
      </Stack>
      <Stack direction='row' w='100%' spacing={4}>
        <Box w='50%' data-testid='quantity'>
          <Text fontWeight='bold'>Quantity</Text>
          <Text className='test-id-quantity'>{quantity}</Text>
        </Box>
        {amount && (
          <Box w='50%' data-testid='amount'>
            <Text fontWeight='bold'>Amount</Text>
            <Text className='test-id-amount'>{numberToDollars(amount)}</Text>
          </Box>
        )}
      </Stack>
    </Stack>
  )
}
